import React from 'react';
import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import Header from './Header';
import Content from './Content';
import SharedFooter from './Footer';
import theme from '../themes/theme';

function AppLayout() {
  return (
    <Box sx={{ minHeight: '100vh', width: '100%', display: 'flex', flexDirection: 'column', bgcolor: 'background.default' }}>
      <CssBaseline />
      <Header />
      <Box component="main" sx={{ flex: 1 }}>
        <Content />
      </Box>
      <SharedFooter />
    </Box>
  );
}

export const AppContainer = () => {
  return (
    <ThemeProvider theme={theme}>
      <AppLayout />
    </ThemeProvider>
  );
};

export default AppContainer;